import { render, staticRenderFns } from "./bindStep2.vue?vue&type=template&id=0c23992e"
import script from "./bindStep2.vue?vue&type=script&lang=js"
export * from "./bindStep2.vue?vue&type=script&lang=js"
import style0 from "./bindStep2.vue?vue&type=style&index=0&id=0c23992e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports